module.exports = __webpack_public_path__ + "static/img/home_service_images_37_h5_zh.d815ae6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_service_images_37_h5_zh.png
// module id = niWD
// module chunks = 34